export default {
  // payload is either a src string, or { src, title }. The title becomes the iframe's
  // accessible name (WCAG SC 4.1.2) - pass one wherever the embedded content is known.
  showIframePopup(context, payload) {
    const { src, title } = typeof payload === 'string' ? { src: payload } : payload || {};

    // A video file inside an <iframe> plays in the browser's bare player: no captions
    // (SC 1.2.2), no transcript, no accessible name. Route it to the real video player.
    if (/\.(mp4|webm|m4v)(?:[?#]|$)/i.test(src || '')) {
      context.dispatch('showVideoPopup', { src, title });
      return;
    }

    context.commit('setIframePopupSrc', src);
    context.commit('setIframePopupTitle', title || '');
    context.commit('setIframePopupVisible', true);
  },
  // payload is either a src string, or { src, title, captions, transcript }.
  // `title` names the dialog (SC 4.1.2). Captions (SC 1.2.2) are picked up automatically
  // from the .vtt beside the MP4, and the transcript (SC 1.2.3) is built from them - see
  // mixins/captionedVideo.js. `captions` / `transcript` only need passing to override that.
  showVideoPopup(context, payload) {
    const { src, title, captions, transcript } =
      typeof payload === 'string' ? { src: payload } : payload || {};

    context.commit('setVideoPopupSrc', src);
    context.commit('setVideoPopupTitle', title || '');
    context.commit('setVideoPopupCaptions', captions || '');
    context.commit('setVideoPopupTranscript', transcript || '');
    context.commit('setVideoPopupVisible', true);
  },
  showHelpPopup(context) {
    context.commit('setHelpPopupVisible', true);
  },
};
